import React, { Component } from "react";
import { Row, Col, Button, Form, Select, message, Input } from "antd";
import "./InvitationList.css";
import { withRouter } from "react-router-dom";
import SendIcon from "../../../svg/svgicon/SendIcon";
import { API } from "../../../API/API";
const { TextArea } = Input;
class Clarification extends Component {
  formRef = React.createRef();
  state = {
    invitationid: this.props.invitationid,
    commentlist: [],
    comment: "",
    dkey: 1,
  };
  componentDidMount = () => {
    this.getData();
  };
  getData = () => {
    API.get(
      "/getComments?vendorid=-1&invitationid=" + this.state.invitationid
    ).then((response) => {
      if (response.status === 200 && response.data.retType == 0) {
        this.setState((prevState) => ({
          commentlist: response.data.retData,
          dkey: prevState.dkey + 1,
        }));
      }
    });
  };
  onChangeClarificationText = (e) => {
    this.setState({
      comment: e.target.value,
    });
  };
  onSendComment = () => {
    let newComment = {
      commenttitle: "MAK",
      comment: this.state.comment,
      vendorid: this.context.vendorid,
      invitationid: this.state.invitationid,
    };
    API.post("/saveComment", newComment).then((response) => {
      if (response.status === 200 && response.data.retType == 0) {
        message.success("Амжилттай илгээгдлээ.");
        this.setState((prevState) => ({
          comment: "",
          commentlist: [...this.state.commentlist, newComment],
          dkey: prevState.dkey + 1,
        }));
      }
    });
  };
  render() {
    return (
      <div key={this.state.dkey}>
        <div className="chatbotContent">
          {this.state.commentlist.map((el) => {
            return (
              <div style={{ padding: 10 }}>
                <Row justify="start">
                  <Col>
                    <div className="Label">{el.commenttitle}</div>
                  </Col>
                  <Col>
                    <div style={{ marginLeft: 10, color: "#636363" }}>
                      {el.commentdate}
                    </div>
                  </Col>
                </Row>
                <Row justify="start">
                  <Col>
                    <div className="chatbox">{el.comment}</div>
                  </Col>
                </Row>
              </div>
            );
          })}
        </div>
        <div style={{ padding: 10, marginTop: 10 }}>
          <TextArea
            placeholder="Захиа бичих"
            onChange={this.onChangeClarificationText}
            defaultValue={this.state.comment}
            rows={5}
          />
        </div>
        <Row justify="end">
          <Col>
            <Button
              type="primary"
              className="btnPrimary"
              style={{
                marginRight: 5,
              }}
              icon={<SendIcon />}
              htmlType="submit"
              onClick={this.onSendComment}
            >
              Илгээх
            </Button>
          </Col>
        </Row>
      </div>
    );
  }
}

export default withRouter(Clarification);
